<template>
  <div class="permission-denied-container">
    <base-spinner v-if="loading" />
    <div v-else>
      <h2>{{ $t("permission-denied") }}</h2>
      <p>
        {{ $t("you-do-not-have-permission") }}
        <router-link to="/"> {{ $t("go-back") }} </router-link>
        {{ $t("or") }}
        <button class="logout-btn p-0" @click="logout">
          {{ $t("log-out") }}
        </button>
      </p>
    </div>
  </div>
</template>

<script>
import JwtUtilService from "@/services/jwt.util.service";

export default {
  data() {
    return {
      loading: false,
    };
  },
  methods: {
    logout() {
      this.loading = true;
      this.$store.dispatch("auth/logout").then(() => {
        window.open(
          `${
            process.env.VUE_APP_KEYCLOAK_URL
          }/logout?post_logout_redirect_uri=${
            window.location.origin
          }/auth/login&id_token_hint=${JwtUtilService.getIdToken()}`,
          "_self"
        );
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.permission-denied-container {
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  height: 100vh;
  background: var(--color-21);
}
a {
  color: var(--color-23) !important;
  background-color: transparent !important;
}
.logout-btn {
  color: var(--color-23) !important;
  background-color: transparent !important;
  border: none !important;
}
</style>
